export var shouldLoadPolyfill = function () { return typeof jest !== 'undefined' || typeof window === 'undefined'; };
//# sourceMappingURL=should-laod-polyfill.js.map